import throttle from 'lodash/throttle';
/* eslint-disable class-methods-use-this */
/**
 * @description This module will will a progress bar on scroll.
 * @param {HTMLElement} domElement - The wrapper that where is progress bar.
 */
export default class ProgressReadBar {
    constructor(domElement) {
        if(!domElement) {
            throw new Error('the element doesn\'t exist');
        }
        if(!domElement.dataset.progressStart || !domElement.dataset.progressEnd) {
            throw new Error('data-progress-start or/and data-progress-end is missing');
        }
        if(domElement.dataset.progressReadBarInitialised === 'true') {
            throw new Error('ProgressReadBar is already init');
        }

        domElement.dataset.progressReadBarInitialised = 'true';

        this.init(domElement);
    }

    /**
     * @description Function that return the % of the scroll zone.
     * @param {HTMLElement} domTop - Element just before the progress bar zone.
     * @param {HTMLElement} domBottom - Element just after the progress bar zone.
     * @returns {number} - The percentage of scrollzone.
     */
    scrollPercentageCalculator(domTop, domBottom) {
        const topPosition = (domTop || document.body).offsetTop;
        const bottomPosition = domBottom ? domBottom.offsetTop : document.body.scrollHeight;

        const scrollableHeight = (document.documentElement.scrollHeight - document.documentElement.offsetHeight) - (document.documentElement.scrollHeight - (bottomPosition + topPosition));
        const scrollTop = window.pageYOffset - topPosition;
        const currentReadPosition = Math.min((scrollTop * 100) / scrollableHeight, 100);

        return currentReadPosition;
    }

    /**
     * @description Fill the progress bar.
     * @param {HTMLElement} elem - The element that will be fill.
     * @param {number} fillingPercentage - Fill of the progress bar in %.
     */
    progressBarFilling(elem, fillingPercentage) {
        if(fillingPercentage > 0) {
            elem.style.width = `${fillingPercentage}%`;
        }
    }

    handleScroll() {
        this.progressBarFilling(this.progressBar, this.scrollPercentageCalculator(this.top, this.bottom));
    }

    init(domElement) {
        this.progressBar = domElement.querySelector('[data-progress-bar]');
        this.top = document.querySelector(domElement.dataset.progressStart);
        this.bottom = document.querySelector(domElement.dataset.progressEnd);

        window.addEventListener('scroll', throttle(this.handleScroll.bind(this)), 16);
    }
}
